import React, { useEffect, useReducer } from 'react';

import { Fieldset } from '@bolt/react-form';
import Button from '@bolt/react-button';
import stateReducer, {
  getSelectsFromProps,
  getGroupValueFromSelectedOptions,
  canShowAddMore,
} from './conditionalSelectReducer';
import ConditionalSelect from './ConditionalSelect';
import { setHierarchy, getFlattenedOptions } from './utils';

const ConditionalSelectSet = (props) => {
  const {
    name,
    options,
    defaultValue,
    label,
    childLabel,
    placeholder,
    childPlaceholder,
    childIsMulti,
    addMoreLabel,
    onChange,
    delimiter,
  } = props;
  if (!options.length) {
    console.warn(`"${type}" is not a valid type`);
    return null;
  }

  const initialState = {
    options: [],
    defaultValue: [],
    groupValue: [],
    selects: [],
    showAddMore: false,
  };

  const [state, dispatchState] = useReducer(stateReducer, initialState, () => {
    const initialSelects = defaultValue?.length
      ? getSelectsFromProps(options, defaultValue)
      : [{ options, defaultValue: [] }];

    let selectedOptions = [];

    if (defaultValue && defaultValue.length) {
      const markedOptions = setHierarchy(options, false);
      const flattenedOptions = getFlattenedOptions(markedOptions);
      const selectedValues = defaultValue.map((o) => o.value);
      selectedOptions = flattenedOptions.filter((o) =>
        selectedValues.includes(o.value),
      );
    }

    return {
      options,
      defaultValue: selectedOptions,
      groupValue: getGroupValueFromSelectedOptions(selectedOptions),
      selects: initialSelects,
      showAddMore: canShowAddMore(initialSelects),
    };
  });

  useEffect(() => {
    if (!state.selects.length) {
      dispatchState({
        type: 'ADD_SELECT',
      });
    }
  }, [state]);

  const AddMoreButton = (props) => {
    const { label } = props;

    const handleAddMoreClick = (e) => {
      dispatchState({
        type: 'ADD_SELECT',
      });
    };

    return (
      <div className="u-bolt-text-align-end">
        <Button hierarchy="secondary" size="small" onClick={handleAddMoreClick}>
          {label}
        </Button>
      </div>
    );
  };

  const GroupValueInput = ({ name, value, delimiter }) => {
    if (!name || !value) return;

    if (delimiter) {
      return <input name={name} type="hidden" value={value.join(delimiter)} />;
    } else {
      return value.length ? (
        value.map((v, i) => (
          <input name={name} type="hidden" value={v} key={i} />
        ))
      ) : (
        <input name={name} type="hidden" />
      );
    }
  };

  return (
    <>
      {state.selects.map((select, i) => {
        return (
          <Fieldset
            legendTitle={placeholder}
            legendAttributes={{
              className: 'u-bolt-visuallyhidden',
            }}
            key={i}>
            <ConditionalSelect
              {...select}
              name={name}
              inputId={`${name}_${i}`}
              placeholder={placeholder}
              childPlaceholder={childPlaceholder}
              label={label}
              childLabel={childLabel}
              childIsMulti={childIsMulti}
              onChange={onChange}
              dispatchState={dispatchState}
            />
          </Fieldset>
        );
      })}
      <GroupValueInput
        name={name}
        value={state.groupValue}
        delimiter={delimiter}
      />
      {state.showAddMore && <AddMoreButton label={addMoreLabel} />}
    </>
  );
};

export default ConditionalSelectSet;
